
    import "src/app/AppSeller/SettingsPage/Warehouses/index.module.scss?farm_css_modules";
    
    export default {"actionButtonsContainer": `actionButtonsContainer-846dac58`,"warehousesList": `warehousesList-846dac58`,"warehousesPage": `warehousesPage-846dac58`}
    